<template>
  <div data-component-name="TableOfContentMobile">
    <div :class="['header', { active }]" @click="active = !active">
      <span>{{ title }}</span>

      <button v-if="active" type="button">
        <SvgIcon name="close" width="20" height="20" />
      </button>

      <SvgIcon v-else name="chevron-down" width="20" height="20" />
    </div>

    <Transition>
      <div class="list-wrapper" v-if="active">
        <ul>
          <TableOfContentItem
            v-for="{ href, title, nested } of items"
            device="mobile"
            :key="href"
            :to="href"
            :title
            :nested
            :activeId
            @close-menu="active = false"
          />
        </ul>
      </div>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import TableOfContentItem from './TableOfContentItem.vue';
import type { IContentTable } from '~/types';

defineProps<{
  title: string;
  activeId: null | string;

  items: Array<IContentTable & { nested?: IContentTable[] }>;
}>();

const active = ref(false);
</script>

<style lang="scss" scoped>
@import '$/mixins/typography';
@import '$/mixins/flex';
@import '$/mixins/media';
@import '$/functions/token';
@import '$/variables/shadows';
@import '$/variables/color-roles';

[data-component-name='TableOfContentMobile'] {
  display: none;
  position: relative;

  @include tablet {
    display: block;

    width: 100%;
    height: auto;

    .header {
      @include flex-center-sb;
      @include subtitle-3;

      padding: 1rem 0;
      margin: 0 2rem;
      border-bottom: 1px solid token('outline-secondary');

      &.active {
        border: none;
      }
    }

    .list-wrapper {
      background-color: token('surf-cont-primary');

      position: absolute;
      z-index: 6;

      top: 100%;
      left: 0;
      right: 0;

      ul {
        max-height: 31.25rem;
        overflow-y: auto;

        margin: 0 1.5rem;
        border-bottom: 1px solid token('outline-secondary');
      }
    }
  }

  @include mobile {
    .header {
      margin: 0 1rem;
      padding: 0.5rem;
    }

    .list-wrapper {
      ul {
        margin: 0 1rem;
      }
    }
  }
}
</style>
